<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Pramuniaga</div>

    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Tambah"
          icon="pi pi-plus"
          class="p-button-success"
          @click="openDialogCreate()"
        />
      </template>
    </Toolbar>

    <DataTable
      :value="salespersons"
      :lazy="true"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :loading="loading.filter"
      @page="getSalesperson($event)"
    >
      <template #header>
        <div class="p-grid p-fluid p-mb-2">
          <div class="p-col">
            <InputText v-model="search.username" placeholder="Nama" />
          </div>
          <div class="p-col">
            <InputText v-model="search.email" placeholder="Email" />
          </div>
          <div class="p-col">
            <InputText v-model="search.phone" placeholder="Phone" />
          </div>
        </div>

        <div class="p-grid p-fluid p-justify-center">
          <div class="p-col-12 p-md-4 p-lg-4">
            <Button
              label="Cari"
              class="p-button-info"
              @click="getSalesperson()"
              v-shortkey="['enter']"
              @shortkey="getSalesperson()"
            />
          </div>
        </div>
      </template>
      <template #empty>Data tidak ada</template>
      <template #loading>Loading ...</template>

      <Column field="name" header="Nama" headerStyle="width: 7em">
        <template #body="slotProps">
          {{ slotProps.data.name }}
        </template>
      </Column>
      <Column field="email" header="Email" headerStyle="width: 10em">
        <template #body="slotProps">
          {{ slotProps.data.email }}
        </template>
      </Column>
      <Column
        field="phone"
        header="Phone"
        headerStyle="width: 10em; text-align: center;"
      >
        <template #body="slotProps">
          <div class="text-center">
            {{ slotProps.data.phone }}
          </div>
        </template>
      </Column>

      <Column field="roles" header="Role" headerStyle="width: 10em">
        <template #body="slotProps">
          {{ (slotProps.data.roles || []).join(', ') }}
        </template>
      </Column>
      <Column field="outlet" header="Outlet" headerStyle="width: 7em">
        <template #body="slotProps">
          <div v-if="slotProps.data.outlet_name">
            {{ slotProps.data.outlet_name }}
          </div>
          <div v-else>-</div>
        </template>
      </Column>
      <Column field="warehouse" header="Warehouse" headerStyle="width: 7em">
        <template #body="slotProps">
          <div v-if="slotProps.data.warehouse_name">
            {{ slotProps.data.warehouse_name }}
          </div>
          <div v-else>-</div>
        </template>
      </Column>
      <Column field="status" header="Status" headerStyle="width: 5.5em">
        <template #body="slotProps">
          <span
            v-if="slotProps.data.status === 1"
            class="p-text-bold"
            style="color: green"
            >Aktif</span
          >
          <span v-else class="p-text-bold" style="color: red">Tidak Aktif</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em">
        <template #body="slotProps">
          <div v-if="slotProps.data.status === 1">
            <Button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success"
              style="margin-right: 10px"
              @click="confirmCancelUpdate(slotProps.data)"
            />
            <Button
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger"
              @click="openDialogDeactive(slotProps.data)"
              :disabled="loading.delete"
            />
          </div>
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="create_dialog"
      :style="{ width: '450px' }"
      header="Tambah Salesperson"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label>Role</label>
        <InputText
          required
          v-model="selected_role"
          placeholder="Role"
          :disabled="true"
        />
        <small class="p-error" v-if="is_error.role">{{ error_msg.role }}</small>
      </div>
      <div class="p-field">
        <label>Nama</label>
        <InputText
          required
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label>Email</label>
        <InputText
          type="email"
          required
          pattern=".+@globex\.com"
          v-model="create_data.email"
          placeholder="Email"
          @keyup.prevent="is_error.email = false"
        />
        <small class="p-error" v-if="is_error.email">{{
          error_msg.email
        }}</small>
      </div>
      <div class="p-field">
        <label>Phone</label>
        <InputText
          type="number"
          placeholder="Phone"
          v-model="create_data.phone"
          required
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.phone
        }}</small>
      </div>
      <div class="p-field">
        <label>Password</label>
        <InputText
          required
          v-model="create_data.password"
          placeholder="Password"
          @keyup.prevent="is_error.password = false"
          type="password"
        />
        <small class="p-error" v-if="is_error.password">{{
          error_msg.password
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="create_dialog = false"
        />
        <Button
          label="Save"
          class="btn btn-primary"
          @click="createSalesperson()"
        >
          Save
          <span v-if="loading_save">
            <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>

    <!-- update salesperson -->
    <Dialog
      :visible.sync="update_dialog"
      :style="{ width: '450px' }"
      header="Edit Salesperson"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label>Role</label>
        <InputText
          required
          v-model="selected_role"
          placeholder="Role"
          :disabled="true"
        />
        <small class="p-error" v-if="is_error.role">{{ error_msg.role }}</small>
      </div>
      <div class="p-field">
        <label>Nama</label>
        <InputText
          required
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label>Email</label>
        <InputText
          type="email"
          required
          pattern=".+@globex\.com"
          v-model="create_data.email"
          placeholder="Email"
          @keyup.prevent="is_error.email = false"
        />
        <small class="p-error" v-if="is_error.email">{{
          error_msg.email
        }}</small>
      </div>
      <div class="p-field">
        <label>Phone</label>
        <InputText
          type="number"
          placeholder="Phone"
          v-model="create_data.phone"
          required
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.phone
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="update_dialog = false"
        />
        <Button
          label="Save"
          class="btn btn-primary"
          @click="updateSalesperson()"
        />
      </template>
    </Dialog>
    <Dialog
      :visible.sync="deactive_dialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Non-Aktifkan Salesperson"
      :modal="true"
      class="p-fluid"
    >
      <div class="confirmation-content">
        Apakah kamu yakin ingin non-aktifkan salesperson
        <b>{{ create_data.name }}</b
        >?
      </div>

      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="deative_dialog = false"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          class="p-button-text"
          @click="deactiveSalesperson()"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      create_dialog: false,
      update_dialog: false,
      deactive_dialog: false,
      loading_save: false,

      loading: {
        filter: false,
        create: false,
        delete: false
      },

      selected_role: null,
      salespersons: [],
      search: {
        username: '',
        email: '',
        phone: ''
      },

      old_email: null,

      create_data: {
        roles: [],
        warehouse_id: 0,
        outlet_id: 0,
        name: '',
        email: '',
        phone: '',
        password: ''
      },

      is_error: {
        name: false,
        email: false,
        phone: false,
        password: false
      },

      error_msg: {
        name: '',
        email: '',
        phone: '',
        password: ''
      },

      limit: 5,
      total_records: 0
    }
  },
  mounted() {
    this.getAuthUser()
    setTimeout(() => {
      this.getRoles()
      this.getSalesperson()
    }, 500)
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    openDialogCreate() {
      this.resetCreateData()
      this.create_dialog = true
    },

    getRoles() {
      this.$http.get(`${process.env.VUE_APP_API_URL}/roles`).then(response => {
        if (response.status === 200) {
          this.selected_role = response.data.data.roles.filter(
            role => role.type === 'SALESPERSON'
          )[0].type
        }
      })
    },

    getSalesperson(event) {
      let page = 1
      if (event) {
        page = event.page + 1
      }

      this.loading.filter = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/employees?outlet_id=${this.user.outlet_id}&role=SALESPERSON&username=${this.search.username}&email=${this.search.email}&phone=${this.search.phone}&page=${page}&limit=${this.limit}`
        )
        .then(response => {
          this.loading.filter = false
          if (response.status === 200) {
            this.salespersons = response.data.data.employees
            this.total_records = response.data.data.total
          }
        })
    },

    createSalesperson() {
      this.create_data.roles = [this.selected_role]
      this.create_data.warehouse_id = 0
      this.create_data.outlet_id = this.user.outlet_id

      if (!this.create_data.name) {
        this.is_error.name = true
        this.error_msg.name = 'Isi nama'
      }
      if (!this.create_data.email) {
        this.is_error.email = true
        this.error_msg.email = 'Isi email'
      }
      if (!this.create_data.phone) {
        this.is_error.phone = true
        this.error_msg.phone = 'Isi phone'
      }
      if (!this.create_data.password) {
        this.is_error.password = true
        this.error_msg.password = 'isi Password'
      }

      this.loading.create = true
      if (
        !this.is_error.role &&
        !this.is_error.name &&
        !this.is_error.email &&
        !this.is_error.phone &&
        !this.is_error.password
      ) {
        this.loading_save = true
        this.$http
          .post(`${process.env.VUE_APP_API_URL}/employees`, this.create_data)
          .then(response => {
            this.loading.create = false

            if (response.status === 200) {
              this.create_dialog = false
              this.getSalesperson()
              this.resetCreateData()

              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil menambahkan salesperson',
                life: 3000
              })
              this.loading_save = false
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal menambahkan salesperson',
                life: 3000
              })
              this.loading_save = false
            }
          })
      }
    },

    resetCreateData() {
      this.selected_outlet = null
      this.selected_warehouse = null
      this.create_data = {
        roles: [],
        warehouse_id: 0,
        outlet_id: 0,
        name: '',
        email: '',
        phone: '',
        password: ''
      }
    },

    confirmCancelUpdate(shift) {
      this.old_email = shift.email
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/employee/detail?email=${shift.email}`
        )
        .then(response => {
          if (response.status === 200) {
            this.create_data = {
              roles: response.data.data.roles || [],
              outlet_id: this.user.outlet_id,
              warehouse_id: 0,
              name: response.data.data.name,
              email: response.data.data.email,
              phone: response.data.data.phone
            }
          }
        })
      this.update_dialog = true
    },

    updateSalesperson() {
      this.create_data.warehouse_id = 0
      this.create_data.roles = [this.selected_role]
      this.create_data.outlet_id = this.user.outlet_id

      if (!this.create_data.name) {
        this.is_error.name = true
        this.error_msg.name = 'Isi nama'
      }
      if (!this.create_data.email) {
        this.is_error.email = true
        this.error_msg.email = 'Isi email'
      }
      if (!this.create_data.phone) {
        this.is_error.phone = true
        this.error_msg.phone = 'Isi phone'
      }

      this.loading.create = true
      if (
        !this.is_error.role &&
        !this.is_error.name &&
        !this.is_error.email &&
        !this.is_error.phone
      ) {
        this.$http
          .put(
            `${process.env.VUE_APP_API_URL}/employees/update?email=${this.old_email}`,
            this.create_data
          )
          .then(response => {
            if (response.status === 200) {
              this.getSalesperson()
              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil update Salesperson',
                life: 3000
              })
              this.resetCreateData()
              this.update_dialog = false
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal update Salesperson',
                life: 3000
              })
            }
          })
      }
    },

    openDialogDeactive(data) {
      this.create_data = data
      this.deactive_dialog = true
    },

    deactiveSalesperson() {
      this.loading.cancel = true
      this.$http
        .patch(
          `${process.env.VUE_APP_API_URL}/employees/deactive?email=${this.create_data.email}`
        )
        .then(response => {
          this.loading.cancel = false
          this.deactive_dialog = false

          if (response.status === 200) {
            this.getSalesperson()

            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil menon-aktifkan salesperson',
              life: 3000
            })
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal menon-aktifkan salesperson',
              life: 3000
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
